import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { QuestionnaireAnswer } from "@/Common/Models/Questionnaires/QuestionnaireAnswer";
import { TemplateFormRenderer } from "./Renderer/TemplateFormRenderer";

interface IQuestionnaireFormComponentProps {
    componentName: string;
    answers: QuestionnaireAnswer[];
    templateFormRenderer: TemplateFormRenderer;

    disabled?: boolean;
    showHeader?: boolean;

    onAnswerChanged?: (answer: QuestionnaireAnswer) => void;
}

class QuestionnaireFormComponent extends BaseReactComponent<IQuestionnaireFormComponentProps> {
    public render(): JSX.Element {
        if (!this.props)
            return null;

        return (
            <div>
                {this.props.showHeader &&
                    this.renderFormHeader()
                }
                {this.props.templateFormRenderer.render(answer => this.handleOnChanged(answer), this.props.disabled)}
            </div>
        );
    }

    private renderFormHeader(): JSX.Element {
        return (
            <div>
                <h3>{this.props.componentName}</h3>
                <hr />
            </div>
        );
    }

    private handleOnChanged(answer: QuestionnaireAnswer): void {
        this.props.onAnswerChanged && this.props.onAnswerChanged(answer);
    }
}

export { QuestionnaireFormComponent };
